import { render, staticRenderFns } from "./AddVtsCenterPractice.vue?vue&type=template&id=3cd0a05e"
import script from "./AddVtsCenterPractice.vue?vue&type=script&lang=ts"
export * from "./AddVtsCenterPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports